<template>
  <div class="announcement-detail-com">
    <div class="announcement-content" v-show="!loading">
      <h2 class="announcement-title" :style="{'background-image': article.img}">{{article.title}}</h2>
    </div>
    <div class="article-content" :class="{'article-detail-mobile': $vuetify.breakpoint.xsOnly}">
      <div class="announcement-title-mobile" v-if="$vuetify.breakpoint.xsOnly">{{article.title}}</div>
      <article class="article-detail" v-html="article.content"></article>
      <!--<ul class="article-share">
        <li>Share</li>
        <li>123<img src="" alt=""></li>
        <li>123<img src="" alt=""></li>
        <li>123<img src="" alt=""></li>
        <li>123<img src="" alt=""></li>
      </ul>-->
    </div>
  </div>
</template>

<script>
  import { articleApi } from '../../../api/announcement/article.module';
  import { mapGetters } from 'vuex';
  import { getterTypes } from '../../../store/getter-types';

  export default {
    name: 'AnnouncementDetail',
    data() {
      return {
        loading: true,
        category: this.$route.query.category,
        article: {},
      };
    },
    methods: {
      // 获取文章详情
      getArticleDetail() {
        articleApi.getArticleDetail(this.$route.query.id)
          .then((res) => {
            this.loading = false;
            this.article = res.data;
          });
      },
    },
    computed: {
      ...mapGetters([getterTypes.Getter_Information_Nav]),
      currentCategory() {
        let navs = this.Getter_Information_Nav;
        let category = {};
        let currentCategory = this.$route.query.category;
        for (let i = 0, len = navs.length; i < len; i++) {
          let item = navs[i];
          if (item.category === currentCategory) {
            category = item;
            break;
          }
        }
        return category;
      },
    },
    mounted() {
      this.getArticleDetail();
    },
  };
</script>

<style lang="stylus" scoped>
  @import "./announcement-detail.scoped.styl"
</style>
